module.exports = __webpack_public_path__ + "static/media/hangry_logo.5eeb952f.png";